<template>
  <footer>
    <div class="bottom_nav">
      <div class="item">
        {{pageTitle}}
      </div>
      <!-- <div class="item">
        企业名录
      </div> -->
      <div class="item">
        <span class="copyright">Copyright© 2021-2026南京中科逆熵科技有限公司版权所有</span>
        <img class="gov_icon" src="@/assets/images/gov_icon.png" alt="">
        <a  target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?record=32011502012639">苏公网安备32011502012639号</a>
        <a target="_blank" class="icp" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2021008172号-2</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    pageTitle () {
      return this.$store.state.config.top || '南京智能计算中心生态应用平台';
    }
  },
}
</script>

<style lang="scss" scoped>
footer {
  width: 1920px;
  height: 65px;
  background: #02142c;
  box-sizing: border-box;
  padding: 0 240px;
  bottom: 0px;
  .bottom_nav {
    height: 100%;
    display: flex;
    color: #fff;
    align-items: center;
    font-size: 15px;
    .item {
      padding: 0 15px;
      display: flex;
      align-items: center;
      a {
        color: rgb(116, 154, 227) !important;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #749ae3;
        letter-spacing: 0;
        font-weight: 400;
        text-decoration: none;
        margin-left: 5px;
      }
      .icp{
        margin-left: 20px;
      }
      .copyright {
        font-size: 12px;
        color: #fff;
        margin-right: 20px;
      }
      /* &:first-child {
        border-right: 2px solid #fff;
      } */
    }
    .gov_icon {
      width: 16px;
      height: 17px;
    }
  }
}
</style>